import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "Roof Maintenance",
    date: "20 Aug, 2024",
    admin: "Admin",
    heading: "Preparing Your Roof for Winter Weather",
    important: {
      content: "Preparing your roof for winter is crucial to safeguarding your home against snow, ice, and cold temperatures. Follow our expert advice to maintain a strong and resilient roof.",
      intro: "Roofing Specialist"
    },
    paragraph: {
      para1: "Ensure your roof is ready for winter with essential maintenance tips and expert advice. Learn how to protect your home from harsh weather conditions.",
      para2: "From sealing leaks to reinforcing shingles, discover key steps to keep your roof in top shape throughout the winter. Dive into our guide and prepare your home for the colder months ahead!",
      para3: "Explore the comprehensive steps needed to winterize your roof effectively. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Visualize the winter preparation process with our curated gallery. Let these examples guide you through the essential steps! Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog1Gallery1,
      images.blog1Gallery2
    ],
    tags: ["Winter", "Maintenance", "Roofing"],
    comments: [
      {
        id: 1,
        image: images.blog1Comment1,
        name: "Benjamin Alexander",
        date: "01 Mar, 2024",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur.",
        replies: [
          {
            id: 1,
            image: images.blog1Comment2,
            name: "Isabella Grace",
            date: "02 Mar, 2024",
            content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
          }
        ]
      },
      {
        id: 2,
        image: images.blog1Comment3,
        name: "Samuel James",
        date: "02 Mar, 2024",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "Roof Installation",
    date: "20 Aug, 2024",
    admin: "Admin",
    heading: "Steps to Installing a New Roof: What to Expect",
    important: {
      content: "Installing a new roof is a major investment that enhances the protection and value of your home. Discover the essential steps involved and what you should prepare for during the process.",
      intro: "Certified Roofing Contractor"
    },
    paragraph: {
      para1: "Learn what to expect during the entire roof installation process—from planning and preparation to the final inspection. These expert steps will ensure a successful and smooth project.",
      para2: "From choosing materials to removing the old roof and installing a new one, get a clear breakdown of every stage. Our guide helps homeowners stay informed and confident.",
      para3: "Explore how roofing professionals handle everything from underlayment to ventilation systems. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Visualize the full roof installation journey with our detailed gallery. These step-by-step visuals offer insight into the transformation process. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog2Gallery1,
      images.blog2Gallery2
    ],
    tags: ["Installation", "Roofing", "Maintenance"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Benjamin Alexander",
        date: "01 Mar, 2024",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur.",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Isabella Grace",
            date: "02 Mar, 2024",
            content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
          }
        ]
      },
      {
        id: 2,
        image: images.blog2Comment3,
        name: "Samuel James",
        date: "02 Mar, 2024",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "Roof Repair",
    date: "12 Sep, 2024",
    admin: "Admin",
    heading: "Repairing Roof Damage After a Storm",
    important: {
      content: "Severe weather can wreak havoc on your roof. Learn how to assess the damage, make necessary repairs, and restore the integrity of your home quickly and safely.",
      intro: "Storm Damage Expert"
    },
    paragraph: {
      para1: "After a heavy storm, it's crucial to inspect your roof for signs of damage like missing shingles, leaks, or structural issues. This guide walks you through the immediate steps you should take.",
      para2: "From temporary fixes to professional repairs, discover how to prevent further interior damage and protect your home. Timing is everything when it comes to post-storm roof repair.",
      para3: "Understand the importance of documenting storm damage for insurance claims and what to expect from a professional roofing inspection. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "See before-and-after visuals of storm-related roof repairs to get an idea of what's possible. Our curated gallery showcases successful restorations. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog3Gallery1,
      images.blog3Gallery2
    ],
    tags: ["Repair", "Storm", "Roofing"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Liam Carter",
        date: "14 Sep, 2024",
        content: "Great advice! We had some serious shingle loss after last month's storm. This really helped.",
        replies: [
          {
            id: 1,
            image: images.blog3Comment2,
            name: "Olivia Morgan",
            date: "15 Sep, 2024",
            content: "Same here! Thanks for sharing these practical steps."
          }
        ]
      },
      {
        id: 2,
        image: images.blog3Comment3,
        name: "Noah Bennett",
        date: "16 Sep, 2024",
        content: "Timely info! Calling my roofer now with photos of the damage."
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "Roof Materials",
    date: "05 Oct, 2024",
    admin: "Admin",
    heading: "Exploring the Best Roofing Tiles for Your Home",
    important: {
      content: "Choosing the right roofing tile can enhance both the durability and aesthetic of your home. Explore the best tile options available and learn which ones suit your climate and style.",
      intro: "Roofing Design Consultant"
    },
    paragraph: {
      para1: "Selecting the perfect roofing tile is about more than just looks. Learn about the pros and cons of clay, concrete, slate, and composite tiles to make a smart decision.",
      para2: "Our expert insights help you weigh longevity, insulation, maintenance, and cost so you can confidently choose the tile that fits your home and budget.",
      para3: "Understand how different tile materials perform in various weather conditions, and how color, texture, and finish can impact your home’s energy efficiency and resale value. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Browse our gallery of premium tile installations to see real-world examples. Get inspired and discover the tile that could transform your rooftop. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog4Gallery1,
      images.blog4Gallery2
    ],
    tags: ["Tiles", "Roofing", "Installation"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Emily Johnson",
        date: "06 Oct, 2024",
        content: "Super helpful comparison! We’re considering clay tiles and this cleared up a lot of confusion.",
        replies: [
          {
            id: 1,
            image: images.blog4Comment2,
            name: "Ryan Foster",
            date: "07 Oct, 2024",
            content: "Same here. I didn’t realize how durable slate could be!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog4Comment3,
        name: "Sophia Lee",
        date: "07 Oct, 2024",
        content: "Loved the gallery. Definitely leaning toward composite now."
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "Roof Maintenance",
    date: "10 Nov, 2024",
    admin: "Admin",
    heading: "Seasonal Roof Maintenance Checklist",
    important: {
      content: "Stay ahead of costly roof repairs with our seasonal maintenance checklist. Learn what to inspect and when to keep your roof in top condition all year round.",
      intro: "Roof Care Planner"
    },
    paragraph: {
      para1: "Maintaining your roof throughout the year prevents small issues from turning into big problems. Our checklist guides you through what to look for each season—spring, summer, fall, and winter.",
      para2: "From clearing gutters and checking shingles to identifying signs of wear, each task is designed to extend the life of your roof and improve home safety and efficiency.",
      para3: "Whether you're a homeowner or property manager, use this step-by-step checklist to stay organized and proactive. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Visual learners can explore our maintenance photo gallery to see what proper upkeep looks like in action. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog5Gallery1,
      images.blog5Gallery2
    ],
    tags: ["Maintenance", "Roofing", "Winter"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "Ava Mitchell",
        date: "11 Nov, 2024",
        content: "This checklist is golden! I printed it and taped it to my garage wall for quick access.",
        replies: [
          {
            id: 1,
            image: images.blog5Comment2,
            name: "Lucas Reed",
            date: "12 Nov, 2024",
            content: "Smart move! I’ve set calendar reminders based on this list."
          }
        ]
      },
      {
        id: 2,
        image: images.blog5Comment3,
        name: "Chloe Wright",
        date: "12 Nov, 2024",
        content: "Fall section really helped me spot a clogged gutter before it got worse. Thank you!"
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "Roof Materials",
    date: "22 Nov, 2024",
    admin: "Admin",
    heading: "Benefits of Metal Roofing: Is It Right for You",
    important: {
      content: "Metal roofing offers a unique blend of durability, efficiency, and style. Discover if this modern roofing solution aligns with your home’s needs and climate.",
      intro: "Roofing Material Advisor"
    },
    paragraph: {
      para1: "Metal roofs are gaining popularity for their sleek appearance and long lifespan. In this article, we break down the advantages of metal roofing and when it makes the most sense.",
      para2: "From energy efficiency and fire resistance to sustainability and design flexibility, learn why metal may be the smart upgrade your roof needs.",
      para3: "We'll also highlight potential drawbacks like cost and noise, so you get a balanced view before deciding. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Browse real-life metal roof installations in our gallery to visualize how this material could transform your home. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog6Gallery1,
      images.blog6Gallery2
    ],
    tags: ["Metal", "Roofing", "Installation"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Liam Carter",
        date: "23 Nov, 2024",
        content: "After reading this, I'm seriously considering a metal roof for our cabin renovation. Thanks!",
        replies: [
          {
            id: 1,
            image: images.blog6Comment2,
            name: "Grace Hall",
            date: "24 Nov, 2024",
            content: "We installed one last year—best decision ever for winter durability!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog6Comment3,
        name: "Mason Brooks",
        date: "24 Nov, 2024",
        content: "Didn’t know they could reflect heat so well. Helpful breakdown!"
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "Roof Maintenance",
    date: "01 Dec, 2024",
    admin: "Admin",
    heading: "Getting Your Roof Ready for Winter Conditions",
    important: {
      content: "Winter can be tough on your roof. Learn the essential steps to prepare it for snow, ice, and freezing temperatures to avoid costly damage.",
      intro: "Winter Roofing Guide"
    },
    paragraph: {
      para1: "Cold weather brings challenges like ice dams, heavy snowfall, and freezing rain. Preparing your roof ahead of time can prevent leaks, structural issues, and energy loss.",
      para2: "This article walks you through winter-proofing strategies—from gutter maintenance and insulation checks to roof inspections and emergency supplies.",
      para3: "We also discuss warning signs of winter roof problems and when to call in professionals. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Take a look at our winter-ready roofing gallery featuring real homes and contractor tips. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog7Gallery1,
      images.blog7Gallery2
    ],
    tags: ["Winter", "Roofing", "Maintenance"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Ella Thompson",
        date: "02 Dec, 2024",
        content: "I followed this guide last year—zero problems during the heaviest snowfall!",
        replies: [
          {
            id: 1,
            image: images.blog7Comment2,
            name: "Nathan Lewis",
            date: "03 Dec, 2024",
            content: "Same here! The checklist really saved me from dealing with frozen gutters."
          }
        ]
      },
      {
        id: 2,
        image: images.blog7Comment3,
        name: "Sophia Clark",
        date: "03 Dec, 2024",
        content: "Perfect timing! I was just planning to book a pre-winter inspection. Great tips."
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "Roof Installation",
    date: "10 Dec, 2024",
    admin: "Admin",
    heading: "A Step-by-Step Guide to Roof Installation",
    important: {
      content: "Installing a new roof is a major project that requires careful planning and execution. This guide outlines the process from prep to final inspection.",
      intro: "Roofing Installation Expert"
    },
    paragraph: {
      para1: "Whether you're building a new home or replacing an old roof, understanding the full installation process can help you make informed decisions.",
      para2: "In this guide, we cover each step: removing the old roofing, preparing the deck, choosing materials, and laying down the new roof with proper ventilation and insulation.",
      para3: "We also explore timing, weather considerations, safety tips, and what to expect from your roofing contractor. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "Browse our gallery to see each phase of installation in real-world projects and get a visual sense of the entire process. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog8Gallery1,
      images.blog8Gallery2
    ],
    tags: ["Installation", "Roofing", "Tiles"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "Logan Davis",
        date: "11 Dec, 2024",
        content: "This is exactly what I needed to feel confident before replacing our old roof.",
        replies: [
          {
            id: 1,
            image: images.blog8Comment2,
            name: "Ava Mitchell",
            date: "12 Dec, 2024",
            content: "Glad I read this before hiring contractors—really helpful breakdown!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog8Comment3,
        name: "Noah Bennett",
        date: "12 Dec, 2024",
        content: "Can’t believe how much I didn’t know about this process. Well explained!"
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "Roof Repair",
    date: "18 Dec, 2024",
    admin: "Admin",
    heading: "Fixing Roof Issues After Storm Damage",
    important: {
      content: "Storms can cause serious damage to your roof. Learn how to assess, repair, and prevent future issues with this post-storm recovery guide.",
      intro: "Emergency Roof Repair"
    },
    paragraph: {
      para1: "High winds, hail, heavy rain, and falling debris can all compromise your roof. Acting quickly after a storm is essential to prevent further damage and costly repairs.",
      para2: "This guide walks you through inspecting your roof safely, identifying signs of damage (like missing shingles or leaks), and deciding whether to DIY or call professionals.",
      para3: "We also explain how to document storm damage for insurance claims, and tips on working with reliable roofing contractors. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "See our before-and-after gallery showing real roof repairs completed after severe storms. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog9Gallery1,
      images.blog9Gallery2
    ],
    tags: ["Storm", "Repair", "Roofing"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Grace Morgan",
        date: "19 Dec, 2024",
        content: "We just had a major storm and this helped me figure out what to check first!",
        replies: [
          {
            id: 1,
            image: images.blog9Comment2,
            name: "Owen Parker",
            date: "20 Dec, 2024",
            content: "Our insurance adjuster actually appreciated the checklist from this article."
          }
        ]
      },
      {
        id: 2,
        image: images.blog9Comment3,
        name: "Liam Rivera",
        date: "20 Dec, 2024",
        content: "Great info! Wish I had this last year when our roof was damaged by hail."
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "Roofing Materials",
    date: "22 Dec, 2024",
    admin: "Admin",
    heading: "Top Roofing Tile Options for Your Home",
    important: {
      content: "Choosing the right roofing tile is essential for durability, style, and weather resistance. Explore the top tile options suited for modern and traditional homes.",
      intro: "Roofing Material Expert"
    },
    paragraph: {
      para1: "From classic clay to modern metal, roofing tiles come in a variety of materials, each with its own aesthetic and performance benefits. This article compares the top types to help you decide.",
      para2: "We break down the pros and cons of clay, concrete, slate, metal, and composite tiles—highlighting durability, cost, weight, and weather resistance for each option.",
      para3: "You’ll also find tips on how to match roofing tiles with architectural styles, energy efficiency considerations, and installation factors. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quam error, odit aut possimus natus dolorem provident, temporibus expedita iure incidunt amet accusantium cum, repellat assumenda dolores mollitia totam! Recusandae, voluptas.",
      para4: "See visual examples in our curated gallery of homes using various tile types. Let your next roof be as stylish as it is strong. Lorem ipsum, dolor sit amet consectetur adipisicing elit. Harum soluta mollitia earum vero similique facilis quo corrupti asperiores, fugiat totam necessitatibus labore voluptate molestiae quam impedit vel. Error, minus aut."
    },
    gallery: [
      images.blog10Gallery1,
      images.blog10Gallery2
    ],
    tags: ["Tiles", "Roofing", "Installation"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Sophia Blake",
        date: "23 Dec, 2024",
        content: "Loved the comparison! Helped me choose between slate and metal tiles.",
        replies: [
          {
            id: 1,
            image: images.blog10Comment2,
            name: "Ethan Gray",
            date: "24 Dec, 2024",
            content: "Concrete tiles are more affordable than I thought. Great guide!"
          }
        ]
      },
      {
        id: 2,
        image: images.blog10Comment3,
        name: "Maya Patel",
        date: "24 Dec, 2024",
        content: "This made choosing roofing materials so much easier—very informative!"
      }
    ]
  }

];

export default blogs;